import { CHANNEL_LABELS, formatInt, type ReachResult } from "@cafe/shared";

export function ReachFunnel({ reach }: { reach: ReachResult }) {
  const pct = reach.matched ? Math.round((reach.reachable / reach.matched) * 100) : 0;
  return (
    <div className="rounded-xl bg-crema p-2.5 text-xs">
      <div className="flex items-baseline justify-between">
        <span className="font-medium">{CHANNEL_LABELS[reach.channel]}</span>
        <span className="tabular-nums">
          <strong className="text-base">{formatInt(reach.reachable)}</strong> contactables de {formatInt(reach.matched)}
        </span>
      </div>
      <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-latte">
        <div className="h-full rounded-full bg-caramel" style={{ width: `${pct}%` }} />
      </div>
      <p className="mt-1 text-[11px] text-roast/80">
        Excluidos: {formatInt(reach.excluded_no_consent)} sin consentimiento · {formatInt(reach.excluded_suspended)} tarjetas suspendidas · {formatInt(reach.excluded_duplicates)} duplicados
      </p>
    </div>
  );
}
